import { useFindDetailContactSentimentQuery } from 'services';
import { FindOneContactSentimentDto } from 'types';

export const useFindDetailContactSentiment = (data?: FindOneContactSentimentDto, options?: any) => {
  const {
    data: DetailSentiment,
    isLoading: isLoadingDetailSentiment,
    isFetching: isFetchingDetailSentiment,
    refetch: refetchDetailSentiment
  } = useFindDetailContactSentimentQuery(data!, {
    refetchOnMountOrArgChange: true,
    skip: !data,
    ...options
  });

  return {
    detail: DetailSentiment?.data,
    isLoadingDetailSentiment,
    isFetchingDetailSentiment,
    refetchDetailSentiment
  };
};
